import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const DELETE_VENUE_IMAGE_FAIL = "VENUE:DELETE_VENUE_IMAGE_FAIL";

export interface DeleteVenueImageFailAction extends Action {
  type: typeof DELETE_VENUE_IMAGE_FAIL;
  id: number;
  organization: OrganizationKeyName;
  imageUrl: string;
}

export const deleteVenueImageFailAction = (
  organization: OrganizationKeyName,
  id: number,
  imageUrl: string
): DeleteVenueImageFailAction => ({
  type: DELETE_VENUE_IMAGE_FAIL,
  id,
  organization,
  imageUrl,
});
